import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn.js';

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  /** Announced politely while indeterminate work is in flight. */
  label?: string;
  size?: 'sm' | 'md';
}

/**
 * PRM-17 Spinner — indeterminate progress. 07-11: a control loading for longer
 * than 400 ms shows a spinner; below that it shows nothing. Callers own that
 * delay; this primitive renders once mounted.
 */
export function Spinner({ label = 'Loading', size = 'md', className, ...props }: SpinnerProps) {
  return (
    <span
      data-primitive="PRM-17"
      role="status"
      aria-live="polite"
      className={cn('inline-flex items-center gap-inline', className)}
      {...props}
    >
      <span
        aria-hidden="true"
        className={cn(
          'inline-block animate-spin rounded-pill border-2 border-line border-t-primary',
          size === 'sm' ? 'h-4 w-4' : 'h-5 w-5',
        )}
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}
